import { useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetMetiers } from "../../hooks/react-query/dropdowns/metiers.queries";
import { MetierTitle } from "../../schemas/etablissement/etablissemen.schema";
import {
  EtablissementFilterValidationSchema,
  EtablissementFilterValidationType,
} from "../../schemas/etablissement/etablissementFitler.schema";
import { LocalisationFilters, useEtablissementStore } from "../../stores/etablissement/etablissement.store";
import CalendarDropdownFilter from "../filters/CalendarDropdownFilter/CalendarDropdownFilter";
import MapsSearchDropdownFilter from "../filters/MapsSearchDropdownFilter/MapsSearchDropdownFilter";
import Loader from "../global/Loader/Loader";
import DropdownSection from "../inputs/DropdownSection/DropdownSection";

import { useTranslation } from "react-i18next";
import GradientButton from "../global/GradientButton/GradientButton";
import styles from "./RechercheBarStart.module.scss";

export default function RechercheBarStart() {
  const { t } = useTranslation();
  //* useState
  const [disponibilitesFilter, setDisponibilitesFilter] = useState<string[]>(
    []
  );
  const [localisation, setLocalisation] = useState<LocalisationFilters>({
    ville: "",
    lat: 0,
    lon: 0
  });

  //* react-router-dom
  const navigate = useNavigate();
  const { pathname } = useLocation()

  const isUsingInHomePage = (): boolean => {
    return pathname === "/"
  }

  //* react-query
  const { data: metiersData, isLoading: isLoadingMetier } = useGetMetiers();
  const metiersOptions = metiersData?.data?.list;

  //* react-form-hook
  const { setError, clearErrors, control, register, formState, handleSubmit } =
    useForm<EtablissementFilterValidationType>({
      resolver: yupResolver(EtablissementFilterValidationSchema(t)),
      defaultValues: {
        metierFilter: "Restauration",
      }
    });

  const formErrors = formState.errors;

  //* zustand
  const { setSelectedMetierFilterValue, setSelectedLoclisationFilterValue } =
    useEtablissementStore();
  function onSubmit(data: EtablissementFilterValidationType) {
    setSelectedMetierFilterValue(data.metierFilter as MetierTitle);
    // setSelectedLoclisationFilterValue(ville);
    navigate("/recherche");
  }


  const sortMetierByAlphabeticOrder = (strArr: any[]): any[] => {
    if (!strArr?.length) return []
    if (typeof strArr[0] === "string") return strArr?.sort((a, b) => a?.localeCompare(b))

    return strArr?.sort((a, b) => a?.label?.localeCompare(b?.label))

  }

  if (isLoadingMetier) return <Loader />;
  return (
    <article className={styles.rechercheBarStart}>
      <form
        className={styles.rechercheBarStart__form}
        onSubmit={handleSubmit(onSubmit)}
      >
        <main className={styles.rechercheBarStart__form__main}>
          <div className={styles.rechercheBarStart__form__main__hidden}>
            <DropdownSection
              label={t("rechercheBarStart.metierLabel")}
              name="metierFilter"
              placeholder="Restauration"
              inputId="metierFilter"
              options={sortMetierByAlphabeticOrder(metiersOptions)}
              control={control}
              isUsingInHomePage={isUsingInHomePage()}
              hasIcon={true}
            />
          </div>
          <div>
            <label
              className={styles.rechercheBarStart__form__main__titleLabel}
            >
              {t("rechercheBarStart.disponibilitesLabel")} {/* Tradução para "Disponibilité(s)" */}
            </label>
            <CalendarDropdownFilter
              disponibilitesFilter={disponibilitesFilter}
              setDisponibilitesFilter={setDisponibilitesFilter}
              register={register}
              isUsingInHomePage={isUsingInHomePage()}
            />
          </div>
          <div>
            <label className={styles.rechercheBarStart__form__main__titleLabel}>
              {t("rechercheBarStart.localisationLabel")} {/* Tradução para "Localisation*" */}
            </label>
            <MapsSearchDropdownFilter
              name={"villeFilter"}
              placeholder={t("rechercheBarStart.localisationPlaceholder")} // Tradução para "Indiquer une ville"
              inputId="villeFilter"
              register={register}
              formErrors={formErrors}
              setError={setError}
              clearErrors={clearErrors}
              localisation={localisation}
              setLocalisation={setLocalisation}
              isUsingInHomePage={isUsingInHomePage()}
            />
          </div>
        </main>

        <footer className={styles.rechercheBarStart__form__footer}>
          <p>{t("rechercheBarStart.requiredFieldsNote")}</p> {/* Tradução para "*Champs obligatoires" */}
          <GradientButton text={t("rechercheBarStart.searchButton")} type="submit" /> {/* Tradução para "Rechercher" */}
        </footer>
      </form>
    </article>
  );
}


interface IMetierOptions {
  label: string
  [x: string]: string
}